import { Box, BoxProps } from '@material-ui/core';

import { StyledSkeleton } from '@/components/modules/AssetDetails/components/shared/StyledSkeleton';
import { FormGridContainer } from '@/components/shared/components/FormGridContainer/FormGridContainer';

interface DetailsDataSkeletonProps extends BoxProps {
  numberOfRows: number;
}

export const DetailsDataSkeleton = ({ numberOfRows, ...props }: DetailsDataSkeletonProps) => {
  return (
    <Box {...props}>
      <FormGridContainer>
        {[...Array(numberOfRows)].map(() => (
          <StyledSkeleton />
        ))}
      </FormGridContainer>
    </Box>
  );
};
